import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export default function useAuthorizationAgreementState(
  initialValue: boolean = false,
): [boolean, React.Dispatch<React.SetStateAction<boolean>>] {
  const [confirmed, setConfirmed] = useState<boolean>(initialValue)

  const isCustomAuthorizationAgreementStore = useSelector(
    (store: any) => store.settings.isCustomAuthorizationAgreement === '1',
  )
  const isDefaultCheckedStore = useSelector(
    (store: any) =>
      store.settings.isCustomAuthorizationAgreementDefaultChecked === '1',
  )

  useEffect(() => {
    if (isCustomAuthorizationAgreementStore) {
      setConfirmed(isDefaultCheckedStore)
    } else {
      setConfirmed(true)
    }
  }, [isDefaultCheckedStore, isCustomAuthorizationAgreementStore])

  return [confirmed, setConfirmed]
}
